import { useNavigate, useLocation } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  let query = useLocation().search;

  return (route: string) => {
    const params = route.includes('?');
    const separator = params ? '&' : '?';

    if (query && params) query = query.replaceAll('?', '&');
    const gtm = new URLSearchParams(query).get('gtm');

    query = gtm ? `${separator}gtm=${gtm}` : '';
    navigate(`${route}${query}`);
  };
};
